/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_Stage_InterviewInputs */

const en_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview`)
};

const de_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch`)
};

const fr_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entretien`)
};

const es_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrevista`)
};

const it_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colloquio`)
};

const nl_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegesprek`)
};

const pl_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmowa kwalifikacyjna`)
};

const fi_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työhaastattelu`)
};

const da_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsamtale`)
};

const sv_analytics_funnel_stage_interview = /** @type {(inputs: Analytics_Funnel_Stage_InterviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbintervju`)
};

/**
* | output |
* | --- |
* | "Interview" |
*
* @param {Analytics_Funnel_Stage_InterviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_stage_interview = /** @type {((inputs?: Analytics_Funnel_Stage_InterviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_Stage_InterviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_stage_interview(inputs)
	if (locale === "fr") return fr_analytics_funnel_stage_interview(inputs)
	if (locale === "es") return es_analytics_funnel_stage_interview(inputs)
	if (locale === "it") return it_analytics_funnel_stage_interview(inputs)
	if (locale === "nl") return nl_analytics_funnel_stage_interview(inputs)
	if (locale === "pl") return pl_analytics_funnel_stage_interview(inputs)
	if (locale === "fi") return fi_analytics_funnel_stage_interview(inputs)
	if (locale === "da") return da_analytics_funnel_stage_interview(inputs)
	if (locale === "sv") return sv_analytics_funnel_stage_interview(inputs)
	return en_analytics_funnel_stage_interview(inputs)
});